import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import { useApi } from "@/lib/useApi";
import { formatDate, formatRp } from "@/lib/api";
import { StatusBadge } from "@/components/shop/StatusBadge";
import { SavedAddressManager } from "@/components/shop/SavedAddresses";

const AuthShell = ({ children }) => (
  <div className="mx-auto grid min-h-[70vh] max-w-6xl lg:grid-cols-2">
    <div className="relative hidden overflow-hidden rounded-xl lg:my-10 lg:flex">
      <img src="/images/yarn2.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
    </div>
    <div className="flex items-center justify-center px-4 py-10">{children}</div>
  </div>
);

export const SignInPage = () => (
  <AuthShell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthShell>
);

export const SignUpPage = () => (
  <AuthShell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthShell>
);

const OrdersList = () => {
  const call = useApi();
  const [orders, setOrders] = useState(null);
  useEffect(() => { call("get", "/me/orders").then(setOrders).catch(() => setOrders([])); }, [call]);
  if (orders === null) return <p className="text-sm text-stone-500">Memuat...</p>;
  if (!orders.length) return <p className="text-sm text-stone-500" data-testid="my-orders-empty">Belum ada pesanan. <Link to="/" className="text-amber-700 underline">Mulai belanja</Link></p>;
  return (
    <div className="divide-y divide-stone-100 rounded-lg border border-stone-200 bg-white" data-testid="my-orders-list">
      {orders.map((o) => (
        <Link key={o.order_id} to={`/bayar/${o.order_id}`} data-testid={`my-order-${o.order_id}`} className="flex items-center gap-4 p-4 hover:bg-stone-50">
          <div className="flex-1"><p className="font-medium">{o.order_id}</p><p className="text-xs text-stone-500">{formatDate(o.created_at)} · {o.items.length} produk</p></div>
          <p className="tnum text-sm font-medium">{formatRp(o.total)}</p>
          <StatusBadge status={o.status} />
        </Link>
      ))}
    </div>
  );
};

export const MyOrders = () => (
  <div className="mx-auto max-w-3xl px-4 py-10 md:px-6">
    <h1 className="mb-6 text-3xl font-semibold">Pesanan Saya</h1>
    <Show when="signed-in"><OrdersList /><SavedAddressManager /></Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </div>
);
